// frontend/src/services/siteImageService.js
import axiosInstance from "./axiosConfig";

const SITE_IMAGES_URL = "/site-images";

/**
 * Get all site images
 * @returns {Object} { images: { slot: { imageUrl, alt, imageType, ... } } }
 */
const getAllSiteImages = async () => {
  const response = await axiosInstance.get(SITE_IMAGES_URL);
  return response.data;
};

/**
 * Get a single site image by slot
 * @param {string} slot - The image slot key
 * @returns {Object} { imageUrl, alt, imageType, pageTitle, pagePath, updatedAt }
 */
const getSiteImage = async (slot) => {
  const response = await axiosInstance.get(`${SITE_IMAGES_URL}/${slot}`);
  return response.data;
};

/**
 * Update a site image (upload file and/or update alt text)
 * @param {string} slot - The image slot key
 * @param {FormData} formData - Contains 'image' file and/or 'alt' text
 * @returns {Object} Updated image data
 */
const updateSiteImage = async (slot, formData) => {
  const response = await axiosInstance.put(
    `${SITE_IMAGES_URL}/${slot}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};

const siteImageService = {
  getAllSiteImages,
  getSiteImage,
  updateSiteImage,
};

export default siteImageService;
